export const Routes = {
    Login : "/login",
    Dashboard: "/dashboard",
    Media: "/media",
    Campaigns: "/campaigns",
    Channels: "/channels",
    ChannelMedia: "/channels/:channelId",
    ChannelPlaylist: "/channels/playlist",
    Reports: "/reports",
    ReportsAdhoc: "/reports/adhoc",
    ReportsSkin: "/reports/skin",
    ReportsSkinAdhoc: "/reports/skinAdhoc",
    PriorityList: "/priorityList",
    PriorityListMedia: "/priorityList/:listId",
    PlayNow: "/playNowList",
    PlayNowMedia: "/playNowList/:listId",
    Users: "/users",
    UserNotifications: "/users/:userId/notifications",
    UserSettings: "/userSettings",
    Players: "/players",
    PlayerDetails: "/players/:id",
    Skins: "/skins",
    SkinDetails: "/skins/:skinId",
    Settings: "/settings",
    ChangeLog: "/changelog",
    PlayersMonitoring: "/monitoring",
    TvGuide: "/tvGuide"
}


export const extractId = (route: string, path: string) => path.replace(`${route}/`, "");
export const createTemplatePathWithId = (route: string) => `${route}/:id`;
export const createPathWithId = (route: string, id: string) => `${route}/${id}`;